import React, { useState, useRef, useEffect } from "react";

//Import CSS
import "../../../App.less";

//Import our Assets
import logo from "../../../assets/MARFish.png";

//Import Mui
import { Box, Button } from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiAutoComplete from "../../controls/MuiAutoComplete";
import Alert from "../../controls/MuiSnackbarAlert";

//Import React Router Dom
import { NavLink, useNavigate } from "react-router-dom";

//Import Reduxtoolkit
import { useDispatch } from "react-redux";

//Import from updatePasswordSlice
import { getUsersFromServer, updateUserPassword } from "./updatePasswordSlice";
import { unwrapResult } from "@reduxjs/toolkit";

const UpdatePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //useState
  const [userName, setUserName] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [userId, setUserId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  //End useState

  //useRef
  const userNameRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const updateRef = useRef(null);
  const loginRef = useRef(null);
  //End useRef

  useEffect(() => {
    dispatch(getUsersFromServer())
      .then(unwrapResult)
      .then((result) => {
        setUserName(result.data);
      });
  }, []);

  const handleUserNameChange = (e, value) => {
    e.preventDefault();
    setSelectedUserName(value);
    if (value) {
      setUserId(value.Id);
    }
    newPasswordRef.current.focus();
  };

  const handleResetPassword = async () => {
    let trimmedNewPassword = newPassword.trim();
    let trimmedConfirmPassword = confirmPassword.trim();
    if (selectedUserName === null) {
      setNotify({
        isOpen: true,
        message: "Username is required",
        severity: "warning",
      });
      userNameRef.current.focus();
      return;
    } else if (trimmedNewPassword === "") {
      setNotify({
        isOpen: true,
        message: "Newpassword is required",
        severity: "warning",
      });
      newPasswordRef.current.focus();
      return;
    } else if (trimmedConfirmPassword === "") {
      setNotify({
        isOpen: true,
        message: "Confirm Password is required",
        severity: "warning ",
      });
      confirmPasswordRef.current.focus();
      return;
    } else if (trimmedNewPassword !== trimmedConfirmPassword) {
      setNotify({
        isOpen: true,
        message: "Password must be match",
        severity: "warning",
      });
      confirmPasswordRef.current.focus();
      return;
    } else {
      let updatedPassword = {
        userId: userId,
        userName: selectedUserName.Username,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      };
      await dispatch(updateUserPassword(updatedPassword))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
            setTimeout(function () {
              navigate("/");
            }, 1000);
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        });
      setSelectedUserName(null);
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <div className="loginPage flex">
      <div className="container flex">
        <Alert notify={notify} setNotify={setNotify} />

        <div className="formDiv flex">
          <div className="headerDiv">
            <img src={logo} alt="Logo Image"></img>
            <h3>Reset your password!</h3>
          </div>

          <div className="inputDiv">
            <MuiAutoComplete
              id="username"
              clearOnEscape
              options={userName}
              getOptionLabel={(option) => {
                if (typeof option === "object" && option !== null) {
                  return option.Username;
                }
                return selectedUserName.Username ?? "";
              }}
              value={selectedUserName}
              onChange={handleUserNameChange}
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  label="User Name *"
                  inputRef={userNameRef}
                  autoFocus
                />
              )}
            />
          </div>
          <div className="inputDiv">
            <MuiTextField
              id="password"
              type="password"
              label="New Password *"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
              inputRef={newPasswordRef}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key.toLowerCase() === "home") userNameRef.current.focus();
              }}
            />
          </div>
          <div className="inputDiv">
            <MuiTextField
              id="password"
              type="password"
              label="Confirm New Password *"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              inputRef={confirmPasswordRef}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key.toLowerCase() === "home")
                  newPasswordRef.current.focus();
              }}
            />
          </div>
          <Box
            sx={{
              display: "flex", // Aligns buttons horizontally
              justifyContent: "space-between", // Adds space between buttons
              alignItems: "center", // Vertically centers the buttons
              gap: 1, // Optional: Adds a gap between buttons
            }}
          >
            <Button
              style={{
                backgroundColor: "#ff771d",
                textTransform: "none",
                fontFamily: "'Roboto', sans-serif",
              }}
              variant="contained"
              size="small"
              onClick={handleResetPassword}
              onKeyDown={(e) => {
                if (e.key.toLowerCase() === "home")
                  confirmPasswordRef.current.focus();
              }}
            >
              Update
            </Button>
            <Button
              style={{
                backgroundColor: "#4154f1",
                textTransform: "none",
                fontFamily: "'Roboto', sans-serif",
              }}
              variant="contained"
              size="small"
              onClick={() => navigate("/")}
              onKeyDown={(e) => {
                if (e.key.toLowerCase() === "home") updateRef.current.focus();
              }}
            >
              Login
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
